import type { ReactElement } from "react"
import { createBrowserRouter, Navigate, type RouteObject, RouterProvider } from "react-router-dom"
import { authRoutes } from "@/pages/auth/routes.tsx"
import dashboardRoutes from "@/pages/dashboard/routes.tsx"
import GlobalErrorPage from "@/pages/global-error-page.tsx"
import { NotFound } from "@/shared/components/guard/404.tsx"
import { AuthGuard } from "@/shared/components/guard/authGuard.tsx"
import { DashboardGuard } from "@/shared/components/guard/dashboardGuard.tsx"
import { useAllowedRoutes } from "@/shared/hooks/use-allowed-routes.ts"
import type { CustomRoute } from "@/shared/types"

const routes: CustomRoute[] = [
  {
    path: "/",
    errorElement: <GlobalErrorPage />,
    element: <Navigate to="/dashboard" />
  },
  {
    path: "/dashboard",
    element: <DashboardGuard />,
    errorElement: <GlobalErrorPage />,
    children: dashboardRoutes
  },
  {
    path: "/auth",
    element: <AuthGuard />,
    errorElement: <GlobalErrorPage />,
    children: authRoutes
  },
  {
    path: "*",
    errorElement: <GlobalErrorPage />,
    element: <NotFound />
  }
]

export function RouteProvider(): ReactElement {
  // Helpers
  const permittedRoutes = useAllowedRoutes(routes)
  return <RouterProvider router={createBrowserRouter(permittedRoutes as RouteObject[])} />
}
